<template>
    <section name='ticketList' class="ticketList">
        <transition-group name="app-fade-scale" appear>
            <div class="tickets colorDeepGray"  v-for="flight in getList(isDepartureOrReturn)" :key="flight.flightId">
                    <div class="ticketRightPart">
                        <div class="logo">
                            <img :src="flight.airline.logoUrl" alt="">
                        </div>
                        <span>{{flight.airline.name}}</span>
                        <span v-if="flight.properties.flightType=='charter'">
                            <svg width="60" height="24" viewBox="0 0 60 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect opacity="0.2" width="60" height="24" rx="12" fill="#55C38C"/>
                            <path d="M20.6426 14.8594C20.459 15.6914 20.0449 16.3672 19.4004 16.8867C18.7598 17.4062 17.9023 17.7676 16.8281 17.9707L16.6406 18.0059L16.5703 17.8301L16.207 16.9043L16.1016 16.6348L16.3828 16.5879C17.3672 16.4004 18.0938 16.082 18.5625 15.6328C19.0312 15.1875 19.2676 14.6016 19.2715 13.875C19.2715 13.8047 19.2695 13.7324 19.2656 13.6582C19.2617 13.584 19.2539 13.5078 19.2422 13.4297C19.2305 13.3516 19.2148 13.2715 19.1953 13.1895C19.1797 13.1074 19.1582 13.0234 19.1309 12.9375C19.1074 12.8477 19.0801 12.7578 19.0488 12.668C19.0215 12.5742 18.9883 12.4805 18.9492 12.3867C18.9141 12.2891 18.875 12.1914 18.832 12.0938L18.7324 11.8652L18.9668 11.7773L19.9453 11.4316L20.1738 11.3496L20.2441 11.5781L20.6074 12.7148C20.6934 12.9766 20.8066 13.166 20.9473 13.2832C21.0879 13.3965 21.2676 13.4531 21.4863 13.4531H21.6504C21.6895 13.4531 21.7266 13.459 21.7617 13.4707C21.7969 13.4785 21.8262 13.4941 21.8496 13.5176C21.873 13.541 21.8926 13.5625 21.9082 13.582C21.9277 13.6016 21.9434 13.6309 21.9551 13.6699C21.9668 13.7051 21.9746 13.7344 21.9785 13.7578C21.9863 13.7773 21.9902 13.8105 21.9902 13.8574C21.9941 13.9043 21.9961 13.9355 21.9961 13.9512C22 13.9668 22.002 13.9961 22.002 14.0391C22.002 14.082 22.002 14.1055 22.002 14.1094V14.25C22.002 14.4961 21.9941 14.6523 21.9785 14.7188C21.9277 14.9023 21.8184 14.9961 21.6504 15H21.5508C21.168 15 20.8652 14.9531 20.6426 14.8594ZM22.002 15H21.5566C21.3652 15 21.2227 14.9277 21.1289 14.7832C21.0312 14.6387 20.9824 14.4609 20.9824 14.25V14.1387C20.9824 13.9473 21.0332 13.7852 21.1348 13.6523C21.2324 13.5195 21.373 13.4531 21.5566 13.4531H22.002C22.584 13.4531 22.9688 13.4004 23.1562 13.2949C23.4102 13.1465 23.5371 12.8066 23.5371 12.2754C23.5371 11.8301 23.4688 11.332 23.332 10.7812L23.2734 10.5527L23.502 10.5L24.457 10.2598L24.668 10.2012L24.7383 10.4121C24.9336 11.0449 25.0312 11.6602 25.0312 12.2578C25.0273 13.293 24.7227 14.041 24.1172 14.502C24 14.5879 23.8672 14.6641 23.7188 14.7305C23.5742 14.793 23.4121 14.8438 23.2324 14.8828C23.0566 14.9219 22.8672 14.9512 22.6641 14.9707C22.4609 14.9902 22.2402 15 22.002 15ZM21.498 8.57227L22.3535 7.72266L22.4121 7.6582L22.4824 7.72266L23.3438 8.57812L23.3496 8.58398L23.3672 8.60742L23.3906 8.58398L23.4023 8.57227L24.2578 7.72266L24.3223 7.6582L24.3867 7.72266L25.2422 8.57812L25.3125 8.64844L25.2422 8.71289L24.3867 9.5625L24.3281 9.63281L24.2578 9.5625L23.4023 8.71289L23.3965 8.70117L23.373 8.67773L23.3496 8.70117L23.3438 8.71289L22.4883 9.5625L22.418 9.63281L22.3535 9.5625L21.498 8.71289L21.4277 8.64258L21.498 8.57227ZM28.3945 11.5605C28.7305 12.377 28.8984 13.1387 28.8984 13.8457C28.9023 14.9668 28.5723 15.873 27.9082 16.5645C27.2441 17.2598 26.2695 17.7285 24.9844 17.9707L24.7969 18.0059L24.7266 17.8301L24.3633 16.9043L24.2578 16.6348L24.5391 16.5879C25.5234 16.4004 26.25 16.082 26.7188 15.6328C27.1875 15.1875 27.4238 14.6016 27.4277 13.875C27.4277 13.8047 27.4258 13.7324 27.4219 13.6582C27.418 13.584 27.4102 13.5078 27.3984 13.4297C27.3867 13.3516 27.3711 13.2715 27.3516 13.1895C27.3359 13.1074 27.3145 13.0234 27.2871 12.9375C27.2637 12.8477 27.2363 12.7578 27.2051 12.668C27.1777 12.5742 27.1445 12.4805 27.1055 12.3867C27.0703 12.2891 27.0312 12.1914 26.9883 12.0938L26.8887 11.8652L27.123 11.7773L28.1016 11.4316L28.3125 11.3555L28.3945 11.5605ZM32.707 14.2441C32.7109 14.498 32.7012 14.666 32.6777 14.748C32.6191 14.916 32.5117 15 32.3555 15H32.2324C30.6387 15 29.8418 14.0742 29.8418 12.2227V6.98438V6.75H30.0762H31.0957H31.3301V6.98438V12.2109C31.3301 13.0391 31.6367 13.4531 32.25 13.4531H32.3555C32.4023 13.4531 32.4434 13.4609 32.4785 13.4766C32.5176 13.4922 32.5508 13.5098 32.5781 13.5293C32.6016 13.5488 32.6211 13.5801 32.6367 13.623C32.6562 13.6621 32.6699 13.6953 32.6777 13.7227C32.6855 13.7461 32.6914 13.7852 32.6953 13.8398C32.7031 13.8906 32.707 13.9258 32.707 13.9453C32.707 13.9648 32.707 14.002 32.707 14.0566C32.707 14.1074 32.707 14.1348 32.707 14.1387V14.2441ZM32.2793 15C32.0879 15 31.9453 14.9277 31.8516 14.7832C31.7539 14.6387 31.7051 14.4609 31.7051 14.25V14.1387C31.7051 13.9473 31.7559 13.7852 31.8574 13.6523C31.9551 13.5195 32.0957 13.4531 32.2793 13.4531H34.0488C34.2832 13.4531 34.4004 13.6816 34.4004 14.1387V14.25C34.4004 14.75 34.2832 15 34.0488 15H32.2793ZM33.9551 15C33.7637 15 33.6211 14.9277 33.5273 14.7832C33.4297 14.6387 33.3809 14.4609 33.3809 14.25V14.1387C33.3809 13.9473 33.4316 13.7852 33.5332 13.6523C33.6309 13.5195 33.7715 13.4531 33.9551 13.4531H35.7246C35.959 13.4531 36.0762 13.6816 36.0762 14.1387V14.25C36.0762 14.75 35.959 15 35.7246 15H33.9551ZM35.6309 15C35.4395 15 35.2969 14.9277 35.2031 14.7832C35.1055 14.6387 35.0566 14.4609 35.0566 14.25V14.1387C35.0566 13.9473 35.1074 13.7852 35.209 13.6523C35.3066 13.5195 35.4473 13.4531 35.6309 13.4531H35.9824C37.2246 13.4531 38.7695 12.9785 40.6172 12.0293C40.418 11.9512 40.1602 11.8477 39.8438 11.7188C39.1055 11.4219 38.6133 11.2734 38.3672 11.2734C38 11.2734 37.6973 11.4258 37.459 11.7305L37.2949 11.9473L37.1777 12.0938L37.0078 12.0117L36.1055 11.5664L35.877 11.4551L36.0117 11.2324L36.1055 11.0742C36.3711 10.6367 36.6953 10.3066 37.0781 10.084C37.4609 9.85742 37.8926 9.74219 38.373 9.73828C38.9043 9.73828 39.5312 9.91406 40.2539 10.2656C41.4453 10.8438 42.3594 11.1465 42.9961 11.1738L43.2188 11.1855V11.4141L43.207 12.4277V12.6445L42.9961 12.6621C42.5742 12.6973 41.7734 13.0254 40.5938 13.6465C38.8867 14.5488 37.3262 15 35.9121 15H35.6309ZM37.8809 16.6992L38.7188 15.8613L38.7832 15.791L38.8535 15.8613L39.6797 16.6934L39.7148 16.7227L39.7383 16.7461L39.7617 16.7227L39.791 16.6992L40.623 15.8613L40.6934 15.791L40.752 15.8613L41.5898 16.6934L41.6602 16.7578L41.5898 16.8281L40.752 17.666L40.6875 17.7305L40.623 17.666L39.791 16.834L39.7559 16.7988L39.7324 16.7754L39.7148 16.7988L39.6797 16.8281L38.8477 17.666L38.7773 17.7305L38.7188 17.666L37.8809 16.834L37.8164 16.7637L37.8809 16.6992ZM38.8242 18.2754L39.6562 17.4316L39.7266 17.373L39.791 17.4316L40.623 18.2695L40.6934 18.334L40.623 18.3984L39.791 19.2363L39.7207 19.3008L39.6504 19.2363L38.8242 18.4043L38.7539 18.334L38.8242 18.2754Z" fill="#16925E"/>
                            </svg>
                        </span>
                        <span v-if="flight.properties.flightType=='system'">
                            سیستمی
                        </span>
                    </div>
                    <div class="ticketCenterPart">
                        <div class="arrow">
                            <svg class="desktop" width="286" height="22" viewBox="0 0 286 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M284.803 17.7237C285.203 17.8324 285.615 17.5966 285.724 17.1969C285.832 16.7972 285.597 16.385 285.197 16.2763L284.803 17.7237ZM0.349061 16.6275C0.143319 16.987 0.267966 17.4452 0.62747 17.6509L6.48592 21.0037C6.84542 21.2095 7.30364 21.0848 7.50939 20.7253C7.71513 20.3658 7.59048 19.9076 7.23098 19.7018L2.02347 16.7216L5.00371 11.5141C5.20946 11.1546 5.08481 10.6964 4.7253 10.4906C4.3658 10.2849 3.90758 10.4095 3.70183 10.769L0.349061 16.6275ZM285.197 16.2763C245.9 5.58663 194.435 0.25 143 0.25C91.5647 0.25 40.0999 5.58663 0.803136 16.2763L1.19686 17.7237C40.3245 7.08004 91.6475 1.75 143 1.75C194.353 1.75 245.675 7.08004 284.803 17.7237L285.197 16.2763Z" fill="#E0E0E0"></path>
                            </svg>
                            <svg class="mobile" width="99" height="19" viewBox="0 0 99 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M97.5328 17.5867C97.8568 17.8447 98.3286 17.7913 98.5867 17.4672C98.8447 17.1432 98.7913 16.6714 98.4672 16.4133L97.5328 17.5867ZM0.254769 16.9156C0.208132 17.3271 0.503977 17.6986 0.915556 17.7452L7.62264 18.5052C8.03422 18.5519 8.40567 18.256 8.45231 17.8444C8.49895 17.4329 8.2031 17.0614 7.79152 17.0148L1.82967 16.3392L2.50522 10.3774C2.55186 9.96578 2.25602 9.59433 1.84444 9.54769C1.43286 9.50105 1.0614 9.7969 1.01476 10.2085L0.254769 16.9156ZM98.4672 16.4133C71.408 -5.13778 27.592 -5.13778 0.532753 16.4133L1.46725 17.5867C27.9796 -3.52889 71.0204 -3.52889 97.5328 17.5867L98.4672 16.4133Z" fill="#E0E0E0"></path>
                            </svg>
                        </div>
                        <div class="originTime">
                            <span class="departuretime" >{{ flight.departureDate | moment("HH:mm")}}</span>
                            <span>{{flight.departure.region}}</span>
                        </div>
                        <div class="ticketType">
                            <span></span>
                            <span>{{getSeatClass(flight.properties.seatClass)}}</span>
                        </div>
                        <div class="destinationTime">
                            <span>-</span>
                            <span>{{flight.arrival.region}}</span>
                        </div>
                    </div>
                    <div class="ticketLeftPart" >
                        <div class="price">
                            <span class="priceBigFont"> {{flight.pricing.adult*$store.state.flight.passengers.adult+flight.pricing.child*$store.state.flight.passengers.child+flight.pricing.infant*$store.state.flight.passengers.infant}} </span>
                            <span class="priceSmallFont">تومان</span>
                        </div>
                        <div class="seatsLeft colorHotPink">
                            <span class="seatsleft" >{{flight.capacity}}</span> صندلی باقی‌مانده
                        </div>
                        <button class="animateMouseOver farsi btn-choose-ticket backgroundSecondary colorWhite"  @click="reserveFlight($store.state.flight.data.tripType,isDepartureOrReturn,flight)">
                            {{getBtnText(`${$store.state.flight.data.tripType}${departureReturn()}`)}}
                        </button>
                    </div>
            </div>
        </transition-group>
    </section>
</template>

<script>
import lodash from 'vue-lodash'
export default {
    props:['localFilter','localSort'],
    data(){
    return {
        data:{
            departureFlightId: '',
            returnFlightId: '',
            adultsCount: this.$store.state.flight.passengers.adult,
            childrenCount: this.$store.state.flight.passengers.child,
            infantsCount: this.$store.state.flight.passengers.infant
        },
        localDepartureFlights:this.$store.state.flight.departureflights,
        localReturnFlights:this.$store.state.flight.returnflights,
        isDepartureOrReturn:'departure',
        items:'0',
        selected: '',
        getElementsNumber:0,
        sortOption: null,
        filterOption: null,
        flightArray:[],
        option: {
        itemSelector: ".element-item",
        layoutMode: 'fitRows',
        getFilterData: {
            'all': function() {
            return true;
            },
            '0-6': function(el) {
            return new Date(el.departureDate).getHours()>0 && new Date(el.departureDate).getHours()<=6;
            },
            '6-10': function(el) {
            return new Date(el.departureDate).getHours()>6 && new Date(el.departureDate).getHours()<=10;
            },
            '10-14': function(el) {
            return new Date(el.departureDate).getHours()>10 && new Date(el.departureDate).getHours()<=14;
            },
            '14-18': function(el) {
            return new Date(el.departureDate).getHours()>14 && new Date(el.departureDate).getHours()<=18;
            },
            '18-24': function(el) {
            return new Date(el.departureDate).getHours()>18 && new Date(el.departureDate).getHours()<=24;
            }
        },
        getSortData: {
            time: function(el){
                return new Date(el.departureDate);     
            },
            price: function(el){
                return el.pricing.adult/**this.$store.state.flight.passengers.adult+el.pricing.child*this.$store.state.flight.passengers.child+el.pricing.infant*this.$store.state.flight.passengers.infant*/;
            }
        },
        }
        
    }
    },
    methods: {
        getSeatClass(seatClass){
            switch(seatClass){
                case 'business':
                return 'بیزنس';
                case 'economy':
                return 'اکونومی'
                case 'first-class':
                return 'فرست کلاس' 
            }
        },
        getRandom(){
            
        },
        getFilteredList(list){
                return list
        },
        reserveFlight(tripType,flightSide,flight){
            if(tripType=='oneway'){
                this.data.departureFlightId=flight.flightId.toString()
                delete this.data.returnFlightId
                this.$store.state.flight.flights.push(flight)
                this.$store.dispatch('reserveFlight',this.data)   
                              
            }else{
                if(flightSide=='departure'){
                    this.data.departureFlightId=flight.flightId.toString()
                    this.$store.state.flight.flights.push(flight)
                    this.isDepartureOrReturn=''                        
                    setTimeout(() => {
                    this.isDepartureOrReturn='return'                        
                    }, 300);
                    this.$store.state.flight.currentDate='return'

                }else if(flightSide=='return'){
                    this.data.returnFlightId=flight.flightId.toString()
                    this.$store.state.flight.flights.push(flight)
                    this.$store.dispatch('reserveFlight',this.data)    

                }
            }
        },
        departureReturn(){
            switch (this.$store.state.flight.data.tripType) {
                case 'oneway':
                    return '';
                case 'roundtrip':
                    return this.isDepartureOrReturn;
            }
        },
        getbtnFunction(trip){
            switch(trip){
                case 'oneway':
                    return 'reserveFlight'
                case 'roundtripDeparture':
                    return 'reserveDepartureFlight'
                case 'roundtripDestination':
                    return 'reserveDestinationFlight'
            }
        },
        getBtnText(trip){
            switch(trip){
                case 'oneway':
                    return 'خرید بلیط'
                case 'roundtripdeparture':
                    return 'خرید بلیط رفت'
                case 'roundtripreturn':
                    return 'خرید بلیط برگشت'
            }
        },
        getOption(){            
            if(this.$store.state.flight.departureflights.length>0){
                return this.option
            }else{
                return  {
                    itemSelector: ".element-item",
                    layoutMode: 'fitRows',
                    getFilterData:{},
                    getSortData:{}
                }
            }
        },
        sort: function() {
            if(this.$store.state.flight.departureflights.length>0){
            }
        },
        filter: function() {
            if(this.$store.state.flight.departureflights.length>0){
            }شب
        },
        changeLayout: function(key) {
        this.$refs.cpt.layout(key);
        },
        getList(flightSide){
            if(flightSide=='departure'){
                if(this.$store.state.flight.departureflights.length>0){
                    this.getElementsNumber=this.localDepartureFlights.length
                    return this.localDepartureFlights
                    
                }
                else{
                    return []
                }
            }else if(flightSide=='return'){
                if(this.$store.state.flight.returnflights.length>0){
                    this.getElementsNumber=this.localDepartureFlights.length
                    return this.localReturnFlights
                }
                else{
                    return []
                }
            }
        },
       
    },
    components:{
    },
    computed:{
        
        getDepartures(){
            return this.$store.state.flight.departureflights
        },
        getReturns(){
            return this.$store.state.flight.returnflights
        }
    },
    watch:{
        getElementsNumber:function(val){
            this.$emit('getElementsNumber',val)
        },
        getDepartures(val){
            
            this.localDepartureFlights = val
        },
        getReturns(val){
            
            this.localReturnFlights = val
        },
        isDepartureOrReturn:function(val){
            this.$emit('departureReturn',val)
        },
        
        localSort:{
            deep:true,
            handler(val){
                let tempProperty
                if(this.isDepartureOrReturn=='departure'){
                    tempProperty='localDepartureFlights'
                }else if(this.isDepartureOrReturn=='return'){
                    tempProperty='localReturnFlights'
                }
                if(val.sortBy=='time'){
                    if(val.sortAscending){
                        this[tempProperty]= this.lodash.sortBy(this[tempProperty],[function(flight){
                            return flight.departureDate
                        }])
                    }else{
                        this[tempProperty]= this.lodash.sortBy(this[tempProperty],[function(flight){
                            return flight.departureDate
                        }]).reverse()
                    }
                
                }
                else if(val.sortBy=='price'){
                    let self = this
                    if(val.sortAscending){
                        this[tempProperty]= this.lodash.sortBy(this[tempProperty],[function(flight){
                            return flight.pricing.adult*self.$store.state.flight.passengers.adult+flight.pricing.child*self.$store.state.flight.passengers.child+flight.pricing.infant*self.$store.state.flight.passengers.infant
                        }])
                    }else{
                        this[tempProperty]= this.lodash.sortBy(this[tempProperty],[function(flight){
                            return flight.pricing.adult*self.$store.state.flight.passengers.adult+flight.pricing.child*self.$store.state.flight.passengers.child+flight.pricing.infant*self.$store.state.flight.passengers.infant
                        }]).reverse()
                    }
                }
            }
        },
        localFilter:{
            deep:true,
            handler(val){
                let tempProperty
                let tempFlights
                if(this.isDepartureOrReturn=='departure'){
                    tempProperty='localDepartureFlights'
                    tempFlights='departureflights'
                }else if(this.isDepartureOrReturn=='return'){
                    tempProperty='localReturnFlights'
                    tempFlights='returnflights'

                }
                let self = this
                if(val.time=='all'){
                        this[tempProperty] = this.lodash.filter(this.$store.state.flight[tempFlights],function(flight){
                            return true
                        })
                }else{
                    let arr = val.time.split('-')
                    if(this.$store.state.flight[tempFlights].length>0){
                        this[tempProperty] = this.lodash.filter(this.$store.state.flight[tempFlights],function(flight){
                            return new Date(flight.departureDate).getHours()>parseInt(arr[0]) && new Date(flight.departureDate).getHours()<=parseInt(arr[1])
                        })
                    }
                }
                if(val.seatClass=='allseats'){
                        this[tempProperty] = this.lodash.filter(this[tempProperty],function(flight){
                            return true
                        })
                }else{
                    if(this.$store.state.flight[tempFlights].length>0){
                        this[tempProperty] = this.lodash.filter(this[tempProperty],function(flight){
                            return flight.properties.seatClass==val.seatClass
                        })
                    }
                }
                if(val.charter=='allmodes'){
                        this[tempProperty] = this.lodash.filter(this[tempProperty],function(flight){
                            return true
                        })
                }else{
                    if(this.$store.state.flight[tempFlights].length>0){
                        this[tempProperty] = this.lodash.filter(this[tempProperty],function(flight){
                            return flight.properties.flightType==val.charter
                        })
                    }
                }
                
            }
        }
    },
    mounted(){
        
    }
}
</script>

<style>

</style>
